module.exports = __webpack_public_path__ + "media/images/weather/10_day-f0ca5f0ed90dc79399c3b25c18306afe.png";